import { magentoApi, serverApi } from './clients';
import { MagentoProduct } from '../types';

class MagentoService {
  async getBanks() {
    return await serverApi.get('/banks');
  }

  async getCustomData(code: string) {
    return await magentoApi.get('/content/getCustomData', {
      params: {
        code,
      },
    });
  }

  async getCampaigns(limit: number, p?: number) {
    return await magentoApi.get('/promotion/getPromoCampaigns', {
      params: {
        limit,
        p,
      },
    });
  }

  async getShowrooms(products: MagentoProduct[]) {
    return magentoApi
      .post('/address/showrooms', products)
      .then((res) => res.data);
  }

  // 23: desktop, 27: mobile
  async getContactContent(store: 23 | 27) {
    return magentoApi
      .get(`/address/getContact?store=${store}`)
      .then(({ data }) => data?.html_content || '');
  }
}

export const magentoService = new MagentoService();
